import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {SkillsCheckerService} from '../service/skills-checker.service';
import {DelegateSimpleModel} from '../../team/models/delegate.model';
import {SkillsCheckerListItemModel, SkillsCheckerModel} from '../model/skills-checker.model';
import {EventsService} from '../../../services/events.service';
import {Subscription} from 'rxjs';
import {TeamService} from '../../team/service/team.service';
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-skills-checker-team',
    templateUrl: './skills-checker-team.component.html',
    styleUrls: ['./skills-checker-team.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class SkillsCheckerTeamComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    scList: SkillsCheckerListItemModel[] = [];
    managers: DelegateSimpleModel[] = null;

    data: SkillsCheckerModel[] = null;
    dataValid = false;
    dataPromise: Promise<SkillsCheckerModel[]> = null;

    scId = 0;
    managerId = 0;

    constructor(
        private analytics: AnalyticsService,
        private router: Router,
        private event: EventsService,
        public userService: UserService,
        private activatedRoute: ActivatedRoute,
        private teamService: TeamService,
        private skillsCheckerService: SkillsCheckerService
    ) {
        this.subscriptions.push(
            this.event.subscribe('skillsChecker:saveSkillsCheckerForm', () => this.dataValid = false)
        );
    }

    ngOnInit() {
        this.teamService.getMyManagersList()
            .then(managers => {
                this.managers = managers;
            });
    }

    ionViewWillEnter() {
        if (this.data === null || !this.dataValid) {
            if (this.scId > 0) {
                this.data = null;
                this.dataPromise = this.skillsCheckerService.getTeamSkillsCheckerList(this.scId, this.managerId);
            } else {
                this.skillsCheckerService.getSkillsCheckersList(this.managerId)
                    .then(data => {
                        this.scList = data;
                        if (this.scList.length > 0) {
                            this.scId = this.scList[0].id;
                        } else {
                            this.data = [];
                            this.scId = 0;
                        }
                        this.selectFilter('sk');
                    });
            }
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Team SkillsChecker');

        if (this.data === null || !this.dataValid) {
            if (this.dataPromise !== null) {
                this.dataPromise.then(data => {
                    this.data = data;
                    this.dataValid = true;
                });
            }
        }
    }

    selectFilter(type) {
        if (type === 'manager') {
            this.data = null;
            this.skillsCheckerService.getSkillsCheckersList(this.managerId)
                .then(data => {
                    this.scList = data;
                    if (this.scList.length > 0) {
                        if (this.scId !== this.scList[0].id) {
                            this.scId = this.scList[0].id;
                        } else {
                            this.getTeamSkillsCheckerList();
                        }
                    } else {
                        this.scId = 0;
                        this.data = [];
                    }
                });
        } else if (type === 'sk') {
            if (this.scId > 0) {
                this.data = null;
                this.getTeamSkillsCheckerList();
            }
        }
    }

    getTeamSkillsCheckerList() {
        this.skillsCheckerService.getTeamSkillsCheckerList(this.scId, this.managerId)
            .then(data => {
                this.data = data;
                this.dataValid = true;
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
